import { FC, useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'

import { addLocalePrefix } from 'lib/addLocalePrefix'
import { useFacilityRecommendations } from 'features/facility/hooks/useFacilityRecommendations'
import SectionBottomBorderTitleComponent from 'components/titles/SectionBottomBorderTitle'

import FacilityCardList from './FacilityCardList'
import styles from './FacilityRecommendationsSection.module.scss'

type Props = {
  latitude: number
  longitude: number
  type: 'city' | 'station'
  prefectureId: number
  locationName: string
  countrySlug: string
  citySlug: string
  localePath: string
  locale: string
}

const FacilityRecommendationsSection: FC<Props> = ({
  latitude,
  longitude,
  type,
  prefectureId,
  locationName,
  countrySlug,
  citySlug,
  localePath,
  locale,
}: Props): JSX.Element | null => {
  const { t } = useTranslation()
  const { facilities, fetchRecommendations } = useFacilityRecommendations()

  useEffect(() => {
    fetchRecommendations({
      latitude,
      longitude,
      type,
      prefecture_id: prefectureId,
    })
  }, [latitude, longitude, type, prefectureId, fetchRecommendations])

  if (facilities.length === 0) {
    return null
  }

  return (
    <section className={styles.section}>
      <div className={styles.sectionContainer}>
        <SectionBottomBorderTitleComponent
          text={t('AREAS.CITY.SLUG.POPULAR_TITLE', {
            location: locationName,
          })}
        />
        <FacilityCardList
          facilities={facilities}
          countrySlug={countrySlug}
          citySlug={citySlug}
          localePath={localePath}
        />
        <p className={styles.sectionOther}>
          <Link
            href={{
              pathname: addLocalePrefix('/locations', locale),
              query: {
                name: locationName,
                lat: latitude,
                lon: longitude,
              },
            }}
          >
            <a className={styles.sectionOtherLink}>
              {t('AREAS.CITY.SLUG.RECOMMENDED_CHECK_AREA_LIST')}
            </a>
          </Link>
        </p>
      </div>
    </section>
  )
}

export default FacilityRecommendationsSection
